<template>
  <v-card class="mx-auto grey lighten-3" flat>
    <v-card-title
      class="headline font-weight-regular justify-space-between py-7"
    >
      {{ openedTopic.name }}
      <v-spacer></v-spacer>
      <v-btn
        v-if="editEverything != 2 && editEverything != 4"
        class="mx-2"
        fab
        dark
        color="primary"
        @click="openCodesForTopic(openedTopic)"
      >
        <v-icon>icons8-access-3</v-icon>
      </v-btn>

      <v-btn
        v-if="editEverything != 2 && editEverything != 4"
        class="mx-2"
        fab
        dark
        color="primary"
        @click="editItem(openedTopic)"
      >
        <v-icon>icons8-edit</v-icon>
      </v-btn>
      <v-btn
        v-if="editEverything != 2 && editEverything != 4"
        class="mx-2"
        fab
        dark
        color="primary"
        @click="deleteItem(openedTopic)"
      >
        <v-icon>icons8-delete-bin</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider class="secondary"></v-divider>
    <v-window v-model="editEverything">
      <v-window-item :value="1">
        <v-card-text class="mx-2">
          <v-row>
            <v-col
              cols="6"
              class="caption font-weight-regular justify-space-between"
            >
              {{ openedTopic.description }}
              <v-spacer></v-spacer>
            </v-col>
            <v-col class="text-right">
              <v-btn
                cols="6"
                class="mx-2"
                dark
                color="primary"
                @click="openAddResources()"
                >ADD RESOURCE</v-btn
              >
            </v-col>
          </v-row>

          <v-text-field
            v-model="search"
            class="mb-2"
            append-icon="icons8-search-2"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <!--resources-datatable -->

          <v-data-table
            :headers="headers"
            :items="newArray"
            :search="search"
            item-key="id"
            single-select
          >
            <template v-slot:[`item.accountCreatedAt`]="{ item }">
              <span class="text-capitalize">{{
                formatDate(item.accountCreatedAt)
              }}</span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-row align="end" justify="end" class="mr-1">
                <v-icon
                  medium
                  class="mr-2 tableForeground--text font-weight-bold"
                  @click="editAresourceItem(item)"
                  >icons8-edit</v-icon
                >
                <v-icon
                  medium
                  class="tableForeground--text font-weight-bold"
                  @click="deleteResourceItem(item)"
                  >icons8-delete-bin</v-icon
                >
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>

        <div class="text-right">
          <v-btn class="mx-2" dark color="primary" v-on:click="closeWindow()">
            <v-icon size="13" left>icons8-delete</v-icon>Cancel
          </v-btn>
        </div>
      </v-window-item>

      <v-window-item :value="2" v-if="editTopicFlag === true">
        <v-form ref="editTopic" v-model="valid" lazy-validation>
          <v-row>
            <!-- The Topic Name Field -->
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-text-field
                v-model="editTopicForm.name"
                outlined
                class="white"
                label="Topic Name"
                append-icon="icons8-male-user"
                hide-details="auto"
                :rules="topicNameRules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-select
                v-model.trim="editTopicForm.status"
                :items="rangeOfStatus"
                :menu-props="{ bottom: true, offsetY: true }"
                outlined
                class="white"
                label="Status"
                append-icon="icons8-expand-arrow-3"
                hide-details="auto"
                :rules="resourceTypeRules"
                required
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-combobox
                v-model.trim="editTopicForm.tags"
                :items="filterTags"
                :menu-props="{ bottom: true, offsetY: true }"
                v-on:keyup.enter="addTagToDB"
                outlined
                class="white"
                multiple
                label="Tags"
                append-icon="icons8-expand-arrow-3"
                hide-details="auto"
                :rules="resourceTypeRules"
                required
              >
              </v-combobox>
            </v-col>
            <!-- The Description Field -->
            <v-col cols="12" xs="12" sm="12" md="12">
              <v-textarea
                v-model="editTopicForm.description"
                outlined
                class="white"
                label="Description"
                hide-details="auto"
                :rules="descriptionRules"
                required
              ></v-textarea>
            </v-col>
            <v-col cols="7" xs="7" sm="8" md="9">
              <v-text-field
                v-model="editTopicForm.buyNowURL"
                outlined
                class="white"
                label="Buy now URL"
                append-icon="icons8-link"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="5" xs="5" sm="4" md="3"> 
              <v-btn
                block
                height="48"
                :href="editTopicForm.buyNowURL"
                target="_blank"
                >Test Url</v-btn
              >
            </v-col>
            <!-- Started Delivery Date-->

            <v-col cols="12" xs="12" sm="12" md="6" ls="6">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="editTopicForm.availableFrom"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editTopicForm.availableFrom"
                    label="Available from"
                    append-icon="mdi-calendar"
                    outlined
                    class="white"
                    readonly
                    v-on="on"
                    clearable
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editTopicForm.availableFrom"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(editTopicForm.availableFrom)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>

            <!--Estimate Delivery Date -->
            <v-col cols="12" xs="12" sm="12" md="6" ls="6">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="editTopicForm.availableTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editTopicForm.availableTo"
                    label="Available to"
                    append-icon="mdi-calendar"
                    outlined
                    class="white"
                    readonly
                    clearable
                    hide-details="auto"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editTopicForm.availableTo"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(editTopicForm.availableTo)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <!-- The Viedo/Image Field -->
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-card class="mx-auto" max-width="350" height="200" outlined style="border: 1px #ADADAD solid !important;">
                <!-- Upload Video Component -->
                <v-card-text class="text-center my-12">
                   <uploadFilesButton  v-if="uploadedFile === null" :storagePath="storagePathProfilePic" :allowedTypes="'video/*'"/>
                    <!-- Show Video after upload -->
                    <p v-else>
                      Uploaded video - {{ uploadedFile.fileName }}
                    </p>
                  <!--/Show Edit Video after upload -->
                </v-card-text>
                <!-- /Upload Video Component -->
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-card
                class="mx-auto align-center justify-center"
                style="border: 1px #ADADAD solid !important;"
                max-width="350"
                height="200"
                outlined
              >
                 <!-- Upload Image Component -->
                  <v-card-text class="text-center my-12" v-if="uploadedFileImg === null" >
                  <uploadFilesImgButton   :storagePath="storagePathProfilePic" :allowedTypes="'image/*'"/>
                  </v-card-text>
                  <!-- /Upload Image Component -->
                  <!-- Show Image after upload -->
                  <v-img
                    v-else
                    :src="uploadedFileImg.fileURL"
                    contain
                    width="344"
                    height="200"
                  ></v-img>
                  <!-- Show Image after upload -->
              </v-card>
            </v-col>
          </v-row>
        </v-form>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          align="end"
          class="ma-0 pa-0"
          justify="bottom"
        >
          <v-row class="pa-0">
            <v-col cols="12" class="ma-0 pa-0" align="end">
              <v-btn
                color="white"
                class="mr-1 primary--text"
                @click="editEverything--"
              >
                <v-icon size="13" left>icons8-delete</v-icon>BACK
              </v-btn>

              <v-btn
                color="primary"
                class="mr-3 px-7"
                @click="
                  saveEdited();
                  closeWindow();
                "
              >
                <v-icon small left></v-icon> SAVE
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-window-item>

      <v-window-item :value="3">
        <v-card class="mx-auto grey lighten-3" flat>
          <v-card-title
            class="subheading-1 font-weight-regular justify-space-between py-7"
            >Edit Specific Resource</v-card-title
          >
          <v-card-text class="text-left mx-2">
            <v-form ref="editResourceFormRef" v-model="valid" lazy-validation>
              <v-row>
                <!-- The Resource Name Field -->
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="editResourceForm.resourceName"
                    outlined
                    class="white"
                    label="Resource Name"
                    hide-details="auto"
                    :rules="resourceNameRules"
                    required
                  ></v-text-field>
                </v-col>

                <!-- The Resource Type Field -->
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model.trim="editResourceForm.resourceType"
                    :items="rangeOfTypes"
                    :menu-props="{ bottom: true, offsetY: true }"
X                outlined
                class="white"
                    label="Resource Type"
                    append-icon="icons8-expand-arrow-3"
                    hide-details="auto"
                    :rules="resourceTypeRules"
                    required
                  ></v-select>
                </v-col>
                <!--The Resource status Field -->
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model.trim="editResourceForm.status"
                    :items="rangeOfStatus"
                    :menu-props="{ bottom: true, offsetY: true }"
                outlined
                class="white"
                    label="Status"
                    append-icon="icons8-expand-arrow-3"
                    hide-details="auto"
                    :rules="resourceTypeRules"
                    required
                  ></v-select>
                </v-col>
              <!-- Resource Tab Selection -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-combobox
                v-model="editResourceForm.tabSelection"
                :items="filterTabSelection"
                :menu-props="{ bottom: true, offsetY: true }"
                v-on:keyup.enter="addTabSelectionToDBFromEdit" 
                 outlined
                class="white"
                label="Tab Selection"
                append-icon="icons8-expand-arrow-3"
                hide-details="auto"
                :rules="resourceTypeRules"
                required
              >
              </v-combobox>
              </v-col>
                <!-- The Resource Description Field -->
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-textarea
                    v-model="editResourceForm.resourceDescription"
                outlined
                class="white"
                    label="Resource Description"
                    hide-details="auto"
                    :rules="resourceDescriptionRules"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Started Delivery Date-->
                <v-col cols="12" xs="12" sm="12" md="6" ls="6">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :return-value.sync="editResourceForm.availableFrom"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editResourceForm.availableFrom"
                        label="Available from"
                        append-icon="mdi-calendar"
                outlined
                class="white"
                hide-details
                        readonly
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editResourceForm.availableFrom"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu3 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.menu3.save(editResourceForm.availableFrom)
                        "
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!--Estimate Delivery Date -->
                <v-col cols="12" xs="12" sm="12" md="6" ls="6">
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :return-value.sync="editResourceForm.availableTo"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editResourceForm.availableTo"
                        label="Available to"
                        append-icon="mdi-calendar"
                outlined
                class="white"
hide-details
                        readonly
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editResourceForm.availableTo"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu4 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu4.save(editResourceForm.availableTo)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" class="text-center my-12">
                    <!-- Upload Resource Component -->
                    <uploadFilesResourceButton  v-if="uploadedFileResource === null" :storagePath="storagePathProfilePic" :allowedTypes="allowedTypes"/>
                      <!-- Show Resource after upload -->
                      <p v-else>
                        Uploaded resource -
                        {{  uploadedFileResource.fileName }}
                      </p>
                    <!-- /Upload Edit Resource Component -->
                  <!--/Show Resource after upload -->
                </v-col>
                <!-- The Marketing checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="editResourceForm.downloadable"
                    class="mx-2"
                    label="Downloadable"
                    hide-details="auto"
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                  By checking this box you are making this resource available for download for any user that will have access to this topic.

                  </p>
                </v-col>
              </v-row>
            </v-form>
            <!--/edit-resources-form-->
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              align="end"
              class="ma-0 pa-0"
              justify="bottom"
            >
              <v-row class="pa-0">
                <v-col cols="12" class="ma-0 pa-0" align="end">
                  <v-btn
                    color="white"
                    class="mr-1 primary--text"
                    @click="editEverything = 1"
                  >
                    <v-icon size="13" left>icons8-delete</v-icon>Cancel
                  </v-btn>

                  <v-btn
                    color="primary"
                    class="mr-3 px-7"
                    @click="saveEditedResource()"
                  >
                    <v-icon small left></v-icon>Change
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <!--end-of-edit-references-col-->
        </v-card>
      </v-window-item>

      <v-window-item :value="4" v-if="editTopicFlag === true">
        <v-card-text>
          <v-row>
            <v-form ref="resources" v-model="valid" lazy-validation>
              <v-row>
                <!-- The Resource Name Field -->
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="FormResources.resourceName"
                outlined
                class="white"

                    label="Resource Name"
                    hide-details="auto"
                    :rules="resourceNameRules"
                    required
                  ></v-text-field>
                </v-col>

                <!-- The Resource Type Field -->
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model="FormResources.resourceType"
                    :items="rangeOfTypes"
                    :menu-props="{ bottom: true, offsetY: true }"
                outlined
                class="white"
                    label="Resource Type"
                    append-icon="icons8-expand-arrow-3"
                    hide-details="auto"
                    :rules="resourceTypeRules"
                    required
                  ></v-select>
                </v-col>
                <!--The Resource status Field -->
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model="FormResources.status"
                    :items="rangeOfStatus"
                    :menu-props="{ bottom: true, offsetY: true }"
                outlined
                class="white"
                    label="Status"
                    append-icon="icons8-expand-arrow-3"
                    hide-details="auto"
                    :rules="resourceTypeRules"
                    required
                  ></v-select>
                </v-col>
              <!-- Resource Tab Selection -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-combobox
                v-model="FormResources.tabSelection"
                :items="filterTabSelection"
                :menu-props="{ bottom: true, offsetY: true }"
                v-on:keyup.enter="addTabSelectionToDB"
                outlined
                class="white"
                label="Tab Selection"
                append-icon="icons8-expand-arrow-3"
                hide-details="auto"
                :rules="resourceTypeRules"
                required
              >
              </v-combobox>
              </v-col>
                <!-- The Resource Description Field -->
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-textarea
                    v-model="FormResources.resourceDescription"
                outlined
                class="white"
                    label="Resource Description"
                    hide-details="auto"
                    :rules="resourceDescriptionRules"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Started Delivery Date-->
                <v-col cols="12" xs="12" sm="12" md="6" ls="6">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                       hide-details="auto"
                    :close-on-content-click="false"
                    :return-value.sync="FormResources.availableFrom"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="FormResources.availableFrom"
                        label="Available from"
                        append-icon="mdi-calendar"
                outlined
                class="white"
                        readonly
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="FormResources.availableFrom"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu3 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu3.save(FormResources.availableFrom)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!--Estimate Delivery Date -->
                <v-col cols="12" xs="12" sm="12" md="6" ls="6">
                  <v-menu
                    ref="menu4"
                    hide-details="auto"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :return-value.sync="FormResources.availableTo"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="FormResources.availableTo"
                        label="Available to"
                        append-icon="mdi-calendar"
                outlined
                class="white"

                        readonly
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="FormResources.availableTo"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu4 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu4.save(FormResources.availableTo)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-card
                    class="mx-auto align-center justify-center"
                    max-width="100%"
                    height="200"
                    outlined
                    v-if="FormResources.resourceType != 'html' && FormResources.resourceType != 'link'"
                  >
                     <!-- Upload Resource Component -->
                  <v-card-text class="text-center my-12">
                    <uploadFilesResourceButton  v-if="uploadedFileResource === null" :storagePath="storagePathProfilePic" :allowedTypes="allowedTypes"/>
                    <!-- Show Resource after upload -->
                    <p v-else>
                      Uploaded resource -
                      {{ uploadedFileResource.fileName }}
                    </p>
                  </v-card-text>
                  <!-- /Upload Resource Component -->
                </v-card>
                <!--/Show Resource after upload -->
              </v-col>
                <!-- The Marketing checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="FormResources.downloadable"
                    class="mx-2"
                    label="Downloadable"
                    hide-details="auto"
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                  By checking this box you are making this resource available for download for any user that will have access to this topic.
                  </p>
                </v-col>
              </v-row>
            </v-form>
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              align="end"
              class="ma-0 pa-0"
              justify="bottom"
            >
              <v-row class="pa-0">
                <v-col cols="12" class="ma-0 pa-0" align="end">
                  <v-btn
                    color="white"
                    class="mr-1 primary--text"
                    @click="editEverything = 1"
                  >
                    <v-icon size="13" left>icons8-delete</v-icon>BACK
                  </v-btn>

                  <v-btn
                    color="primary"
                    class="mr-3 px-7"
                    @click="saveNewResources()"
                    v-on:keyup.enter="saveNewResources()"
                  >
                   UPLOAD
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-window-item>
    </v-window>

    <!--topic-codes-dialog-->
    <v-dialog v-model="codesDialog" persistent>
          <GenerateTopicCodes :topicIdForCodes="topicIdForCodes" :topicForCodes="topicForCodes"  v-on:close-topic-codes="closeCodesDialog" />
    </v-dialog>
    <!--/topic-codes-dialog-->
  </v-card>
</template>

<script>
import FilestackUpload from "../page-components/FilestackUpload.vue";
import GenerateTopicCodes from "./GenerateTopicCodes.vue";
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";
import { mapGetters, mapState, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store


export default {
  name: "EditTopic",
  components: {
    FilestackUpload,
    GenerateTopicCodes,
  },
  props: {
    resourceList: {
      type: Array,
      required: true,
    },
    filestackAPI: {
      type: Array,
      required: true,
    },
    changeWindowsFlag: {
      type: Boolean, //open invite user window
      required: true,
    },
    editTopicFlag: {
      type: Boolean,
      require: true,
    },
    openedTopic: {
      type: Object,
      required: true,
    },
    topicsList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    newArray: [],
    codesDialog: false,
    codeForTopic: [],
    codesList: [],
    topicContent: [],
    tabsSelectionList:[],
    editEverything: 1,
    search: "",
    rangeOfStatus: ["Draft", "Published"],
    tagsList: [],
    rangeOfTypes: ["pdf", "html", "image", "video", "link"],
    valid: true,

    isUploading: false, //upload progress bar
    allowedTypes: "image/*, video/*, audio/*, text/*, .pdf, .PPT, .ppt, .PPTX, .pptx, .docx, .doc, .xls, .xlsx, .csv" ,
    folder: '',
    storagePathProfilePic: 'resources',
    topicIdForCodes: "", // for code integration
    topicForCodes: {},
    //filestack integration
    uploadEditResultImage: "Nothing", // image edit upload holder
    uploadEditResultVideo: "Nothing", // video edit upload holder
    uploadResultResource: "Nothing", // resource add upload holder
    uploadEditResultResource: "Nothing", // resource edit upload holder
    //menus
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    //Lists

    //forms
    //resource form
    FormResources: {
      resourceName: "",
      resourceType: "",
      resourceDescription: "",
      downloadable: false,
      tabSelection: "",
      url: "",
      type:"",
      topicId: "",
      status: "",
      availableFrom: "",
      availableTo: "",
      createdBy: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
    },
    //edit resource form
    editedResourceIndex: -1,
    editedResourceId: null,
    editResourceForm: {
      resourceName: "",
      resourceType: "",
      tabSelection: "",
      resourceDescription: "",
      downloadable: false,
      url: "",
      type:" ",
      topicId: "",
      status: "",
      availableFrom: "",
      availableTo: "",
      createdBy: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
    },
    //edit topic form
    editedIndex: -1,
    editedId: null,
    editTopicForm: {
      name: "",
      description: "",
      videoURL: "",
      photoURL: "",
      buyNowURL: "",
      tags: [],
      status: "",
      availableFrom: "",
      availableTo: "",
      createdBy: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
    },

    // the topic form
    FormTopic: {
      id: "",
      name: "",
      description: "",
      videoURL: "",
      photoURL: "",
      status: "",
      tags: [],
      availableFrom: "",
      availableTo: "",
      createdBy: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
    },
    //tables
    headers: [
      {
        text: " Name",
        align: "start",
        filterable: false,
        value: "resourceName",
      },
      { text: "Type", value: "resourceType" },
      //{ text: "Description", value: "resourceDescription" },
      { text: "Downloadable", value: "downloadable" },
      { text: "Status", value: "status" },
      { text: "Available From", value: "availableFrom" },
      { text: "Available To", value: "availableTo" },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        hidden: false,
        align: "end",
      },
    ],
    //rules
    topicNameRules: [(v) => !!v || "Full topic name is required"],
    descriptionRules: [(v) => !!v || "Some description is required"],
    resourceNameRules: [(v) => !!v || "Full Resource name is required"],
    resourceTypeRules: [(v) => !!v || "The Resource type is required"],
    resourceDescriptionRules: [
      (v) => !!v || "Some description of the topic is required",
    ],
  }),
  computed: {
     ...mapState({
                uploadedFile: (state) => state.upload_file_store.file,
                uploadedFileImg: (state) => state.upload_file_img_store.file,
                uploadedFileResource: (state) => state.upload_file_resource_store.file
    }),
    filterTags() {
      var objTags = [];
      for (var i = 0; i < this.tagsList.length; i++) {
        objTags.push(this.tagsList[i].name);
      }
      return objTags;
    },
      filterTabSelection(){
      var objTabs = [];
      for(var i=0; i< this.tabsSelectionList.length; i++){
        objTabs.push(this.tabsSelectionList[i].name);
      }
      return objTabs;
    },
  },
  watch: {
     uploadedFile: {
      handler: function() {
        this.uploadedFile;
      },
      deep: true
     },
     uploadedFileImg: {
      handler: function() {
        this.uploadedFileImg;
      },
      deep: true
    },
    uploadedFileResource: {
      handler: function() {
        this.uploadedFileResource;
      },
      deep: true
    },
    openedTopic() {
      this.filterResourcesTopic(this.openedTopic.id);
    },
    //for edit topic
    uploadEditResultImage() {
      this.editTopicForm.photoURL = this.uploadEditResultImage[0].url;
    },

    uploadEditResultVideo() {
      this.editTopicForm.videoURL = this.uploadEditResultVideo[0].url;
    },
    // for add resource
    uploadResultResource() {
      this.FormResources.url = this.uploadResultResource[0].url;
    },
    // for edit resource
    uploadEditResultResource() {
      this.editResourceForm.url = this.uploadEditResultResource[0].url;
    },
  },
  methods: {
    isVideo(fileType) {
      switch (fileType) {
        case 'video/m4v':
        case 'video/avi':
        case 'video/mpg':
        case 'video/mp4':
          return true;
      }
      return false;
    },
    isImage(fileType) {
      switch (fileType) {
        case 'image/jpg':
        case 'image/gif':
        case 'image/bmp':
        case 'image/png':
        case 'image/jpeg':
          //etc
          return true;
      }
      return false;
    },
     //add/udate the tabs on the list and db
    addTabSelectionToDB(){
        var self = this;
        if( !this.filterTabSelection.includes(self.FormResources.tabSelection)){ 
           var form = {name:self.FormResources.tabSelection};
             self.$firebase.db
          .collection("tabs")
          .doc()
          .set(form)
          .then((docRef) => {})
          .catch((error) => {
         //   console.log("Error adding document: ", error);
          });
        self.tabsSelectionList.push(form)
        
      }
    },
     addTabSelectionToDBFromEdit(){
        var self = this;
        if( !this.filterTabSelection.includes(self.editResourceForm.tabSelection)){ 
           var form = {name:self.editResourceForm.tabSelection};
             self.$firebase.db
          .collection("tabs")
          .doc()
          .set(form)
          .then((docRef) => {})
          .catch((error) => {
         //   console.log("Error adding document: ", error);
          });
        self.tabsSelectionList.push(form)
        
      }
    },
    //method to retrieve the tabs from the db
    readTabsSelectionFromDB(){
      var self = this;
      this.$firebase.db
        .collection("tabs")
        .onSnapshot((querySnapshot) => {
          self.tagsList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.tabsSelectionList.push(Data);
          });
        });
    },
    //add/udate the tags on the list and db
    addTagToDB() {
      var self = this;
      for (var i = 0; i < self.editTopicForm.tags.length; i++) {
        if (!this.filterTags.includes(self.editTopicForm.tags[i])) {
          var form = { name: self.editTopicForm.tags[i] };
          self.$firebase.db
            .collection("tags")
            .doc()
            .set(form)
            .then((docRef) => {})
            .catch((error) => {
            //  console.log("Error adding document: ", error);
            });
          self.tagsList.push(form);
        }
      }
    },
    //method to retrieve the tags from the db
    readTagsFromDB() {
      var self = this;
      this.$firebase.db.collection("tags").onSnapshot((querySnapshot) => {
        self.tagsList = [];
        var Data = [];
        querySnapshot.forEach((doc) => {
          Data = doc.data();
          Data.id = doc.id;
          self.tagsList.push(Data);
        });
      });
    },
    //topic keys function
    readCodesForTopic(id) {
      var self = this;
      this.$firebase.db
        .collection("codes")
        .where("topicId", "==", id)
        .onSnapshot((querySnapshot) => {
          self.codesList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.codesList.push(Data);
          });
        });
    },
    //generate codes dialog
    openCodesForTopic(item) {
      this.topicIdForCodes = item.id;
      //console.log(typeof item)
      this.topicForCodes = item;
    //  console.log(this.topicIdForCodes);
      this.codesDialog = true;
    },
    closeCodesDialog() {
      this.codesDialog = false;
      this.topicIdForCodes = "";
      this.topicForCodes = {};
    },
    //edit resources methods
    editItem(item) {
      this.editedIndex = this.topicsList.indexOf(item);
      this.editTopicForm = Object.assign({}, item);
    //  console.log("when open " + JSON.stringify(this.editTopicForm, null, 2));
      this.editedId = item.id;
      // console.log("Why " + this.editedId);
      //this.clearTopicForm(item);
      this.editTopicFlag = true;
      this.editEverything++;
    },
    editAresourceItem(item) {
      this.editedResourceIndex = this.newArray.indexOf(item);
      this.editResourceForm = Object.assign({}, item);
      // console.log(item.id);
      this.editedResourceId = item.id;
      this.editEverything = 3;
    },
    deleteResourceItem(item) {
      const index = this.newArray.indexOf(item);
      var id = item.id;
      this.$snotify.confirm(
        "Are you sure you want to delete this resource?",
        "Delete Resource",
        {
          titleMaxLength: 250,
          maxOnScreen: 1,
          closeOnClick: false,
          pauseOnHover: true,
          position: SnotifyPosition.centerCenter,
          buttons: [
            //Yes
            {
              text: "Yes",
              action: (toast) => this.yesActionResource(id, index, toast),
              bold: false,
            },
            //No
            { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
          ],
        }
      );
    },
    yesActionResource(id, index, toast) {
      var self = this;
      // delete topic from firebase collection
      this.$firebase.db
        .collection("resources")
        .doc(id)
        .delete()
        .then(() => {
          self.$snotify.success("The resource was deleted.");
        })
        .catch((error) => {
          self.$snotify.error(error);
        });
      this.newArray.splice(index, 1); // remove user from datatable
      this.$snotify.remove(toast.id);
    },
    openAddResources() {
      this.editTopicFlag = true;
      this.editEverything = 4;
      this.clearResourcesForm();
    },
    clearResourcesForm() {
      this.FormResources.tabSelection="";
      this.FormResources.resourceName = "";
      this.FormResources.resourceDescription = "";
      this.FormResources.resourceType = "";
      this.FormResources.url = "";
      this.FormResources.topicId = "";
      this.FormResources.downloadable = false;
      this.FormResources.status = "";
      this.FormResources.availableFrom = "";
      this.FormResources.availableTo = "";
      this.FormResources.modifiedBy = "";
      this.FormResources.modifiedTimestamp = "";
      this.FormResources.createdBy = "";
      this.FormResources.createdTimestamp = "";
      this.$store.commit("upload_file_resource_store/setFile", null);
      this.FormResources.type="";
    },

    clearTopicForm() {
      this.editTopicForm.name = "";
      this.editTopicForm.description = "";
      this.editTopicForm.videoURL = "";
      this.editTopicForm.photoURL = "";
      this.editTopicForm.tags = "";
      this.editTopicForm.status = "";
      this.editTopicForm.availableFrom = "";
      this.editTopicForm.availableTo = "";
      this.editTopicForm.modifiedBy = "";
      this.editTopicForm.modifiedTimestamp = "";
      this.editTopicForm.createdBy = "";
      this.editTopicForm.createdTimestamp = "";
      this.$store.commit("upload_file_store/setFile", null); 
      this.$store.commit("upload_file_img_store/setFile", null);
    },
    saveNewResources() {
      var self = this;
      if (this.$refs.resources.validate()) {
        self.FormResources.createdTimestamp = self.$moment().toISOString();
        self.FormResources.createdBy = self.$store.getters.currUser.fullName;
        self.FormResources.topicId = self.openedTopic.id;
        if(self.uploadedFileResource != null){
        self.FormResources.url = self.uploadedFileResource.fileURL;
        self.FormResources.type =self.uploadedFileResource.fileType;
        }
        self.$firebase.db
          .collection("resources")
          .doc()
          .set(self.FormResources)
          .then((docRef) => {
            self.$snotify.info("The resource was created.");
          })
          .catch((error) => {
         //   console.log("Error adding document: ", error);
            self.$snotify.error(error);
          });
        self.resourceList.push(self.FormResources);
        self.filterResourcesTopic(self.openCodesForTopic.id);
        self.editEverything = 1;
      } else {
        //  console.log("not valid");
        self.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    saveEditedResource() {
      var self = this;
      if (this.$refs.editResourceFormRef.validate()) {
        self.editResourceForm.modifiedTimestamp = self.$moment().toISOString();
        self.editResourceForm.modifiedBy =
        self.$store.getters.currUser.fullName;
        
        if(self.uploadedFileResource != null){
          self.editResourceForm.url = self.uploadedFileResource.fileURL;
          self.editResourceForm.type = self.uploadedFileResource.fileType;
        }
        self.$firebase.db
          .collection("resources")
          .doc(self.editedResourceId)
          .set(self.editResourceForm)
          .then((docRef) => {
            self.$snotify.info("The resource was edited.");
          })
          .catch((error) => {
           // console.log("Error adding document: ", error);
            self.$snotify.error(error);
          });

        Object.assign(
          self.newArray[self.editedResourceIndex],
          self.editResourceForm
        );
        var id = self.editResourceForm._id;
        delete self.editResourceForm._id;

        self.editEverything = 1;
      } else {
        //  console.log("not valid");
        self.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    //edit topic methods
    deleteItem(item) {
      this.$snotify.confirm(
        "Are you sure you want to delete this topic?",
        "Delete Topic",
        {
          titleMaxLength: 250,
          maxOnScreen: 1,
          closeOnClick: false,
          pauseOnHover: true,
          position: SnotifyPosition.centerCenter,
          buttons: [
            //Yes
            {
              text: "Yes",
              action: (toast) => this.yesAction(item.id, item.index, toast),
              bold: false,
            },
            //No
            { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
          ],
        }
      );
    },
    yesAction(id, index, toast) {
      var self = this;
      // delete topic from firebase collection
      this.deleteAllResources(id);
      this.$firebase.db
        .collection("topics")
        .doc(id)
        .delete()
        .then(() => {
          self.$snotify.success("The topic was deleted.");
        })
        .catch((error) => {
          self.$snotify.error(error);
        });
      this.topicsList.splice(index, 1); // remove user from datatable
      this.$snotify.remove(toast.id);
      this.closeWindow();
    },

    deleteAllResources(id) {
      for (var i = 0; i < this.resourceList.length; i++) {
        if (this.resourceList[i].topicId === id) {
          var self = this;
          // delete topic from firebase collection
          this.$firebase.db
            .collection("resources")
            .doc(self.resourceList[i].id)
            .delete()
            .then(() => {
              // self.$snotify.success("The resource was deleted.");
            })
            .catch((error) => {
              //  self.$snotify.error(error);
            });
        }
      }
    },

    saveEdited() {
      var self = this;
      if (self.$refs.editTopic.validate()) {
        self.editTopicForm.modifiedTimestamp = self.$moment().toISOString();
        self.editTopicForm.modifiedBy = self.$store.getters.currUser.id;
        // console.log(
        //   "About to save" + JSON.stringify(this.editTopicForm, null, 2)
        // );
        if( self.uploadedFile != null && self.isVideo(self.uploadedFile.fileType)){
          self.editTopicForm.videoURL = self.uploadedFile.fileURL;         
        } 
        if ( self.uploadedFileImg != null && self.isImage(self.uploadedFileImg.fileType)){
           self.editTopicForm.photoURL = self.uploadedFileImg.fileURL;
        }
        self.$firebase.db
          .collection("topics")
          .doc(self.editedId)
          .set(self.editTopicForm)
          .then((docRef) => {
            self.$snotify.info("The topic was edited.");
          })
          .catch((error) => {
         //   console.log("Error adding document: ", error);
            self.$snotify.error(error);
          });

        self.editEverything--;
      } else {
        //  console.log("not valid");
        self.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },

    formatDate(date) {
      date = this.$moment(date).format("MMMM Do YYYY, HH:mm");
      return date;
    },
    closeWindow() {
      this.$emit("close-window");
    },
    filterResourcesTopic(id) {
      //console.log("hi" + id);
      var self = this;
      self.newArray = this.resourceList.filter(function(item) {
        //  console.log("hi 2 "+ item.topicId);
        return self.openedTopic.id === item.topicId;
      });
      return self.newArray;
    },
  },
  created() {
    var self = this;
   // console.log(self.openedTopic);
    this.filterResourcesTopic(self.openedTopic.id);
    this.readTagsFromDB();
    this.readTabsSelectionFromDB();
  },
  mounted(){
    this.$store.commit("upload_file_store/setFile", null); 
    this.$store.commit("upload_file_img_store/setFile", null);
    this.$store.commit("upload_file_resource_store/setFile", null);

  }
};
</script>
